export const getAdStatuStyles = () => ({
  dropdown: {
    '&.fui-Dropdown': {
      borderColor: '#605e5c',
      '&:hover': {
        borderColor: '#605e5c',
      },
    },
    '&:after': {
      display: 'none',
    },
  },
  selectedOption: {
    backgroundColor: '#f3f2f1',
  },
  option: {
    '& span': {
      display: 'none',
    },
  },
});

